import React from 'react';
import { KpiCard } from './shared/KpiCard';
import { BarChart } from './shared/BarChart';
import { PieChart } from './shared/PieChart';
import { UsersIcon, TrophyIcon, CheckCircleIcon, BriefcaseIcon, ArrowUpIcon, ArrowDownIcon } from 'lucide-react';
export const DashboardOverview: React.FC = () => {
  // Sample data - in a real app, this would come from an API
  const kpiData = [{
    title: 'Active Users',
    value: '2,543',
    change: '+12%',
    trend: 'up',
    icon: <UsersIcon size={20} data-id="element-211" />,
    color: 'blue'
  }, {
    title: 'Avg. Match Score',
    value: '87%',
    change: '+3%',
    trend: 'up',
    icon: <TrophyIcon size={20} data-id="element-212" />,
    color: 'purple'
  }, {
    title: 'Assessment Completion',
    value: '76%',
    change: '-2%',
    trend: 'down',
    icon: <CheckCircleIcon size={20} data-id="element-213" />,
    color: 'green'
  }, {
    title: 'Top Career Matches',
    value: '128',
    change: '+5%',
    trend: 'up',
    icon: <BriefcaseIcon size={20} data-id="element-214" />,
    color: 'orange'
  }];
  const topCareersData = {
    labels: ['UX Designer', 'Data Scientist', 'Product Manager', 'Marketing Specialist', 'Software Engineer'],
    values: [245, 210, 185, 165, 150]
  };
  const assessmentCompletionData = {
    labels: ['Completed', 'In Progress', 'Not Started'],
    values: [65, 20, 15],
    colors: ['#4CAF50', '#FFC107', '#F44336']
  };
  const weeklySignupsData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    values: [45, 52, 38, 65, 73, 42, 35]
  };
  return <div className="space-y-6" data-id="element-215">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-216">
        {kpiData.map((kpi, index) => <KpiCard key={index} title={kpi.title} value={kpi.value} change={kpi.change} trend={kpi.trend as 'up' | 'down'} icon={kpi.icon} color={kpi.color as 'blue' | 'purple' | 'green' | 'orange'} data-id="element-217" />)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-218">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-219">
          <div className="flex justify-between items-center mb-6" data-id="element-220">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-221">
              Top Recommended Careers
            </h2>
            <div className="text-sm text-gray-500" data-id="element-222">This Month</div>
          </div>
          <BarChart labels={topCareersData.labels} values={topCareersData.values} height={250} color="#7D56F4" data-id="element-223" />
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-224">
          <div className="flex justify-between items-center mb-6" data-id="element-225">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-226">
              Assessment Completion
            </h2>
            <div className="text-sm text-gray-500" data-id="element-227">Current Status</div>
          </div>
          <div className="flex justify-center" data-id="element-228">
            <PieChart labels={assessmentCompletionData.labels} values={assessmentCompletionData.values} colors={assessmentCompletionData.colors} height={250} data-id="element-229" />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6" data-id="element-230">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-231">
          <div className="flex justify-between items-center mb-6" data-id="element-232">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-233">
              Weekly User Signups
            </h2>
            <select className="border border-gray-300 rounded-md text-sm py-1 px-2" data-id="element-234">
              <option data-id="element-235">This Week</option>
              <option data-id="element-236">Last Week</option>
              <option data-id="element-237">Last 30 Days</option>
            </select>
          </div>
          <BarChart labels={weeklySignupsData.labels} values={weeklySignupsData.values} height={250} color="#19D3DA" data-id="element-238" />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-239">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 col-span-2" data-id="element-240">
          <div className="flex justify-between items-center mb-4" data-id="element-241">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-242">
              Recent Users
            </h2>
            <button className="text-sm text-[#7D56F4] hover:underline" data-id="element-243">
              View All
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-244">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-245">
              <thead data-id="element-246">
                <tr data-id="element-247">
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-248">
                    User
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-249">
                    Date Joined
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-250">
                    Progress
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-251">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-252">
                {[{
                name: 'Alex Morgan',
                date: 'Jun 14, 2023',
                progress: 85,
                status: 'Active'
              }, {
                name: 'Jamie Chen',
                date: 'Jun 13, 2023',
                progress: 62,
                status: 'Active'
              }, {
                name: 'Taylor Swift',
                date: 'Jun 12, 2023',
                progress: 45,
                status: 'Inactive'
              }, {
                name: 'Morgan Freeman',
                date: 'Jun 10, 2023',
                progress: 92,
                status: 'Active'
              }].map((user, index) => <tr key={index} data-id="element-253">
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-254">
                      <div className="flex items-center" data-id="element-255">
                        <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 mr-2" data-id="element-256">
                          {user.name.charAt(0)}
                        </div>
                        <div className="text-sm font-medium text-gray-900" data-id="element-257">
                          {user.name}
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-258">
                      {user.date}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-259">
                      <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-260">
                        <div className="h-2 rounded-full bg-[#7D56F4]" style={{
                      width: `${user.progress}%`
                    }} data-id="element-261"></div>
                      </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-262">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${user.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-263">
                        {user.status}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-264">
          <div className="flex justify-between items-center mb-4" data-id="element-265">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-266">
              System Status
            </h2>
            <div className="flex items-center" data-id="element-267">
              <span className="inline-block w-2 h-2 rounded-full bg-green-500 mr-1" data-id="element-268"></span>
              <span className="text-xs text-gray-500" data-id="element-269">
                All Systems Operational
              </span>
            </div>
          </div>
          <div className="space-y-4" data-id="element-270">
            {[{
            name: 'Assessment Engine',
            status: 'Operational',
            latency: '145ms'
          }, {
            name: 'Recommendation API',
            status: 'Operational',
            latency: '210ms'
          }, {
            name: 'User Database',
            status: 'Operational',
            latency: '85ms'
          }, {
            name: 'Analytics Pipeline',
            status: 'Operational',
            latency: '320ms'
          }].map((service, index) => <div key={index} className="flex justify-between items-center p-3 bg-gray-50 rounded-md" data-id="element-271">
                <div data-id="element-272">
                  <div className="text-sm font-medium text-gray-900" data-id="element-273">
                    {service.name}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-274">
                    Latency: {service.latency}
                  </div>
                </div>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-275">
                  {service.status}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};